export default __webpack_public_path__ + "static/media/like_button.svg.df7219e9.png";